export default "__VITE_ASSET__46Ca17Cg__"